var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductBaby(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_3739343"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.4494 9.26007C34.8205 9.26007 45.3761 1.29785 52.7828 1.29785C60.1894 1.29785 75.745 5.55563 75.745 39.629C75.745 73.7023 54.8183 78.7023 46.6716 78.7023C8.52276 78.7045 -7.77279 9.26007 19.4494 9.26007Z",
    fill: "#FBE2E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M40.8337 65.5554C31.6292 65.5554 24.167 58.0932 24.167 48.8888V31.111C24.167 21.9066 31.6292 14.4443 40.8337 14.4443C50.0381 14.4443 57.5003 21.9066 57.5003 31.111V48.8888C57.5003 58.0932 50.0381 65.5554 40.8337 65.5554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M40.8343 41.111C48.1981 41.111 54.1676 35.1415 54.1676 27.7777C54.1676 20.4139 48.1981 14.4443 40.8343 14.4443C33.4705 14.4443 27.501 20.4139 27.501 27.7777C27.501 35.1415 33.4705 41.111 40.8343 41.111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M43.0565 40.911C42.3454 41.0443 41.5899 41.111 40.8343 41.111C33.4788 41.111 27.501 35.1332 27.501 27.7777C27.501 20.4221 33.4788 14.4443 40.8343 14.4443C41.5899 14.4443 42.3454 14.511 43.0565 14.6443C36.7454 15.6888 31.9454 21.1777 31.9454 27.7777C31.9454 34.3777 36.7454 39.8666 43.0565 40.911Z",
    fill: "#D586B0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M28.6114 48.8893V31.8515C26.6492 28.3648 28.3803 23.987 28.1337 20.3359C25.6648 23.2426 24.167 27.0004 24.167 31.1115V48.8893C24.167 58.0893 31.6337 65.5559 40.8337 65.5559C41.5892 65.5559 42.3225 65.5115 43.0559 65.4004C34.9003 64.3115 28.6114 57.3337 28.6114 48.8893Z",
    fill: "#FBE2E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M40.8343 67.2218C30.7254 67.2218 22.501 58.9973 22.501 48.8885V31.1107C22.501 21.0018 30.7254 12.7773 40.8343 12.7773C50.9432 12.7773 59.1676 21.0018 59.1676 31.1107V48.8885C59.1676 58.9973 50.9432 67.2218 40.8343 67.2218ZM40.8343 16.1107C32.5632 16.1107 25.8343 22.8396 25.8343 31.1107V48.8885C25.8343 57.1596 32.5632 63.8885 40.8343 63.8885C49.1054 63.8885 55.8343 57.1596 55.8343 48.8885V31.1107C55.8343 22.8396 49.1054 16.1107 40.8343 16.1107Z",
    fill: "#6B1D66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M40.834 42.7773C32.5629 42.7773 25.834 36.0485 25.834 27.7773C25.834 19.5062 32.5629 12.7773 40.834 12.7773C49.1051 12.7773 55.834 19.5062 55.834 27.7773C55.834 36.0485 49.1051 42.7773 40.834 42.7773ZM40.834 16.1107C34.4007 16.1107 29.1673 21.344 29.1673 27.7773C29.1673 34.2107 34.4007 39.444 40.834 39.444C47.2673 39.444 52.5007 34.2107 52.5007 27.7773C52.5007 21.344 47.2673 16.1107 40.834 16.1107Z",
    fill: "#6B1D66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M27.2632 59.9689L26.6299 56.6956C37.721 54.5511 48.2499 48.6134 56.2832 39.9756L58.7232 42.2445C50.2143 51.3978 39.0388 57.6911 27.2632 59.9689Z",
    fill: "#6B1D66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M43.4626 53.8826C34.7849 53.0981 27.836 49.127 22.8115 42.0781L25.5249 40.1426C30.0226 46.4515 35.9893 49.8604 43.7626 50.5604L43.4626 53.8826Z",
    fill: "#6B1D66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M36.945 24.4447C37.8655 24.4447 38.6117 23.6985 38.6117 22.778C38.6117 21.8575 37.8655 21.1113 36.945 21.1113C36.0245 21.1113 35.2783 21.8575 35.2783 22.778C35.2783 23.6985 36.0245 24.4447 36.945 24.4447Z",
    fill: "#6B1D66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M44.7233 24.4447C45.6438 24.4447 46.39 23.6985 46.39 22.778C46.39 21.8575 45.6438 21.1113 44.7233 21.1113C43.8028 21.1113 43.0566 21.8575 43.0566 22.778C43.0566 23.6985 43.8028 24.4447 44.7233 24.4447Z",
    fill: "#6B1D66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M40.8337 36.1115C39.1759 36.1115 37.6048 35.1382 36.167 33.2227L38.8314 31.2227C40.3381 33.2293 41.327 33.2293 42.8337 31.2227L45.4981 33.2227C44.0626 35.1404 42.4914 36.1115 40.8337 36.1115Z",
    fill: "#6B1D66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M65.8343 14.569C63.9965 14.569 62.501 13.0735 62.501 11.2357C62.501 9.3979 63.9965 7.90234 65.8343 7.90234C67.6721 7.90234 69.1676 9.3979 69.1676 11.2357C69.1676 13.0735 67.6721 14.569 65.8343 14.569ZM65.8343 10.1246C65.2232 10.1246 64.7232 10.6223 64.7232 11.2357C64.7232 11.849 65.2232 12.3468 65.8343 12.3468C66.4454 12.3468 66.9454 11.849 66.9454 11.2357C66.9454 10.6223 66.4454 10.1246 65.8343 10.1246Z",
    fill: "#D586B0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductBaby);
export default __webpack_public_path__ + "static/media/product-baby.35cf066c7c53ef75a447135581bcce42.svg";
export { ForwardRef as ReactComponent };